<template>

  <!--自定义富文本弹窗-->
  <!--<div class="red-new-alert" @click="closeFun">-->
    <!--<p class="mask" @click="closeFun()"></p>-->
    <!--<div class="red-new-alert-con border-box">-->
      <!--<h3>{{shopname}}</h3>-->
      <!--<div v-html="richTxt"></div>-->

      <!--<div class="red-new-btn" @click.stop="closeFun" v-else>知道了</div>-->
    <!--</div>-->
  <!--</div>-->

  <div class="alert-focus">
    <div class="mask" @click="closeFun()"></div>
    <div class="focus-con">
      <div class="focus-tit" v-if="shopname">
        <h3>{{shopname}}</h3>
      </div>
      <div class="focus-richTxt" v-html="richTxt">
        <!--
        <p style="margin: 10px auto 0;text-align: center;">
          <a href="https://mp.weixin.qq.com/s/237AglbUy7Kopg23MzLpQg" style="display: inline-block;width: 42%;margin: 0 10px;">
            <img src="https://filewc.geeker.com.cn//wcrecord/upload/baidu/20200515/282y1jgxdgLxwpa1nf2g71wh2bfp5wf17dyp9w.jpg" alt="" style="width: 100%;height: auto;">
          </a>
          <a href="http://wuhoutscapp.hanchaoculture.com/" style="display: inline-block;width: 42%;margin: 0 10px;">
            <img src="https://filewc.geeker.com.cn//wcrecord/upload/baidu/20200515/1x7212wj38w5fbbgam1ycweh61jajgwejhj8nb.jpg" alt="" style="width: 100%;height: auto;">
          </a>
        </p>
        -->
      </div>
      <img class="focus-close"  v-on:click="closeFun()" src="../assets/focus-close.png" alt="">
    </div>
  </div>

</template>

<script>

  import {getCouponAtRandom} from '@/utils/wechat'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{

      }
    },
    created(){

    },
    props: ['comeForm','shopname','richTxt'],
    computed: {

    },
    methods: {
      //关闭弹窗
      closeFun(){
        this.$emit('close', '');
      }

    },
  }
</script>


<style>
  .focus-con section{word-break: break-all; }
</style>
<style scoped>

  .alert-focus{position: fixed;z-index:10;left:0;top:0;width: 100%;height: 100%;}
  .alert-focus .mask{position: absolute;top:0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.52);}
  .focus-con{position:absolute;top:45%;left:50%;width: 88%;max-height: 70vh;padding-top:.2rem;padding-bottom:.72rem;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);border-radius: .16rem;background: #fff;}
  .focus-tit{ position: relative; text-align: center; width: 80%; margin: .6rem auto .4rem; }
  .focus-tit:before{ position: absolute; left: 50%; top: 50%; content: ''; margin: -.01rem 0 0 -40%; width: 80%; height: .02rem; background-color: #999; }
  .focus-tit h3{ position: relative; z-index: 1; display: inline-block; font-size: .4rem; padding: 0 .15rem; background-color: #fff; color: #222; }
  .focus-richTxt{display: block; width: 94%; margin: .1rem auto 0;max-height: 70vh; overflow-y: auto; }
  .focus-close{position:absolute;left:50%;bottom:-.96rem;width: .53rem;height: auto;margin-left: -.265rem;}
  .focus-text span{color: #909090;}

</style>



// WEBPACK FOOTER //
// src/components/AlertRichTxtTip.vue